<template>
    <div class="dd-card">
        <iframe
            :src="`${metabaseUrl}/${type}/${uuid}?company_id=${companyUuid}`"
            frameborder="0"
            width="100%"
            height="500"
            allowtransparency
        ></iframe>
    </div>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
    name: 'ChartPie',
    props: {
        uuid: String,
        type: String
    },
    data() {
        return {
            companyUuid: '',
            metabaseUrl: ''
        }
    },
    mounted() {
        this.companyUuid = JSON.parse(localStorage.getItem('company')).uuid
        this.metabaseUrl = process.env.VUE_APP_METABASE_PUBLIC_URL
    },

    methods: {}
}
</script>

<style scoped>
.dd-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
    padding: 8px;
}

.dd-card iframe {
    border-radius: 12px;
}
</style>
